import React, { useState, useCallback } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useUser } from '@edwin/react-sdk'

import { CheckCircle } from 'react-feather'
import ReactMarkdown from 'react-markdown'
import { Switch } from '@headlessui/react'
import { AButton } from '../atoms/AButton'

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g

export const MChatOathChecklist = ({
  title,
  oaths,
  textBeforeOaths,
  first,
  onProceed = () => {},
}) => {
  const { user } = useUser()
  const [checkedOaths, setCheckedOaths] = useState(oaths.map(() => false))
  const [areAllOathsChecked, setAreAllOathsChecked] = useState(false)
  const [isOathed, setIsOathed] = useState(false)

  const toggleOathAtIndex = useCallback(
    index => {
      const newCheckedOaths = [...checkedOaths]
      newCheckedOaths[index] = !newCheckedOaths[index]
      const newAreAllOathsChecked = !newCheckedOaths.includes(false)

      setCheckedOaths(newCheckedOaths)
      setAreAllOathsChecked(newAreAllOathsChecked)
    },
    [checkedOaths]
  )

  const handleOnProceed = () => {
    if (areAllOathsChecked) {
      setIsOathed(true)
      onProceed()
    } else {
      alert('Please check all options first')
    }
  }

  return (
    <div
      className={classnames(
        'py-3.5 px-4 border-2 transition-all duration-200 rounded-lg',
        areAllOathsChecked ? 'border-transparent' : 'border-red-500'
      )}
    >
      <div className="flex flex-col items-center">
        {title && <h4 className="text-2xl mb-1.5">{title}</h4>}
        {textBeforeOaths && <p className="mb-3 font-bold">{textBeforeOaths}</p>}
        <ul>
          {oaths.map((oath, index) => (
            <li key={index} className="mb-4">
              <Switch.Group as="div" className="flex items-center">
                <Switch
                  checked={checkedOaths[index]}
                  onChange={() => {
                    toggleOathAtIndex(index)
                  }}
                  onKeyPress={e => {
                    if (e.key === 'Enter') {
                      toggleOathAtIndex(index)
                    }
                  }}
                  disabled={isOathed}
                  className={classnames(
                    checkedOaths[index] ? 'bg-[#DAB6DB]' : 'bg-jagger',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-[#DAB6DB] rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
                  )}
                >
                  <span
                    aria-hidden="true"
                    className={classnames(
                      checkedOaths[index] ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 rounded-full bg-gray-50 shadow transform ring-0 transition ease-in-out duration-200'
                    )}
                  />
                </Switch>
                <Switch.Label as="span" className="ml-3">
                  <ReactMarkdown className="text-sm font-medium">
                    {_.template(oath)({ user })}
                  </ReactMarkdown>
                </Switch.Label>
              </Switch.Group>
            </li>
          ))}
        </ul>
        {!isOathed ? (
          <AButton
            small
            disabled={!areAllOathsChecked}
            outline={!areAllOathsChecked}
            onClick={handleOnProceed}
          >
            Confirm
          </AButton>
        ) : (
          <div className="mt-px py-2 uppercase font-medium">Confirmed</div>
        )}
      </div>
    </div>
  )
}

MChatOathChecklist.propTypes = {
  title: PropTypes.string,
  textBeforeOaths: PropTypes.string,
  oaths: PropTypes.array,
  onProceed: PropTypes.func.isRequired,
  first: PropTypes.bool,
}
